import { useStore } from '../../stores/useStore'

export default function Footer() {
  const transport = useStore((state) => state.transport)
  const setPosition = useStore((state) => state.setPosition)
  const setLoop = useStore((state) => state.setLoop)
  const steps = 16
  const currentStep = Math.floor(transport.position) % 16

  return (
    <footer className="daw-footer">
      <div className="timeline">
        <div className="time-display">
          Bar {Math.floor(currentStep / 4) + 1}·{currentStep % 4 + 1}
        </div>

        <div className="timeline-grid">
          {Array.from({ length: steps }).map((_, i) => {
            const isActive = i === currentStep
            const isLoopStart = transport.loop && i === 0
            const isBarStart = i % 4 === 0
            return (
              <div
                key={i}
                className={`timeline-step ${isActive ? 'active' : ''} ${isLoopStart ? 'loop-marker' : ''}`}
                style={isBarStart && !isActive ? { background: '#444' } : undefined}
                onClick={() => setPosition(i)}
                title={`Step ${i + 1}`}
              />
            )
          })}
        </div>

        <div className="loop-controls">
          <input
            type="checkbox"
            checked={transport.loop}
            onChange={(e) => setLoop(e.target.checked)}
          />
          <span>Loop</span>
        </div>
      </div>
    </footer>
  )
}
